// extracted by mini-css-extract-plugin
export var boldText = "_45-4";
export var checkboxContainer = "_45-6";
export var closeIcon = "_45-i";
export var container = "_45-0";
export var drawer = "_45-8";
export var drawerContent = "_45-9";
export var extraSmallText = "_45-5";
export var fulfillmentGroupTable = "_45-e";
export var largeText = "_45-3";
export var loadingSpinnerContainer = "_45-j";
export var mediumText = "_45-2";
export var narrow = "_45-f";
export var notificationLink = "_45-l";
export var packageCheckIconContainer = "_45-7";
export var slideoutHeaderActions = "_45-g";
export var slideoutHeaderActionsShifted = "_45-h";
export var slideoutHeaderContainer = "_45-a";
export var slideoutModal = "_45-c";
export var stickyHeaderWrapper = "_45-b";
export var table = "_45-k";
export var tableContainer = "_45-d";
export var tertiaryText = "_45-1";